import Button from "@edaz/edazkit/Button/index";
import { registerView } from "@frui.ts/views";
import { ViewComponent } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import React from "react";
import { Modal } from "react-bootstrap";
import ReactMarkdown from "react-markdown";
import CodeChangedAlertViewModel from "viewModels/chargeManagement/chargeManagementEdit/codeChangedAlertViewModel";

const CodeChangedAlertView: ViewComponent<CodeChangedAlertViewModel> = observer(({ vm }) => {
  return (
    <Modal show={true} onHide={vm.onHide} centered>
      <Modal.Header>
        <Modal.Title>{vm.translate("title")}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="mt-n4 mb-4">
          <ReactMarkdown className="markdown">{vm.description}</ReactMarkdown>
        </div>
        <Button onClick={vm.onHide}>{vm.translate("ok")}</Button>
      </Modal.Body>
    </Modal>
  );
});

registerView(CodeChangedAlertView, CodeChangedAlertViewModel);
